<template>
  <div id="app_signup">
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-8>
        <v-card id="app_height" outlined tile>
          <div>
            <vue-element-loading :active="appLoading" :is-full-screen="true" />
            <v-layout wrap pt-10>
              <v-flex xs12 md12 text-center>
                <span style="font-size:20px;font-weight:500;">Contact Us</span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center pt-3>
              <v-flex xs12 md6 pa-5>
                <!-- <v-layout wrap pb-5>
                  <v-flex xs12 md6 text-center>
                    <v-btn
                      text
                      color="black"
                      small
                      block
                      :disabled="inptDisable"
                      :ripple="false"
                      class="text-capitalize"
                      @click="investoracc"
                    >Individual Investor</v-btn>
                    <v-progress-linear :value="investorBar" color="#fb6b0b" height="4"></v-progress-linear>

                  </v-flex>
                  <v-flex xs12 md6 text-center>
                    <v-btn
                      text
                      block
                      color="black"
                      small
                      :disabled="inptDisable"
                      :ripple="false"
                      class="text-capitalize"
                      @click="companyacc"
                    >Company</v-btn>
                    <v-progress-linear :value="companyBar" color="#fb6b0b" height="4"></v-progress-linear>
                  </v-flex>
                </v-layout>-->
                <v-layout wrap justify-center>
                  <v-flex xs9 sm12 md5 text-center align-self-center>
                    <v-radio-group v-model="userType">
                      <v-layout wrap justify-center>
                        <v-flex v-for="(item,i) in userTypes" :key="i" text-center>
                          <v-radio color="#26af82" :label="item" :value="item" :ripple="false"></v-radio>
                        </v-flex>
                      </v-layout>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12 sm12 md6 pr-2>
                    <v-text-field
                      ref="firstName"
                      v-model="firstName"
                      :rules="[rules.required]"
                      label="First Name"
                      color="#26af82"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      ref="lastName"
                      v-model="lastName"
                      :rules="[rules.required]"
                      label="Last Name"
                      color="#26af82"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-text-field
                  ref="mailId"
                  v-model="mailId"
                  :rules="[rules.required,rules.email]"
                  label="Email"
                  color="#26af82"
                  required
                ></v-text-field>
                <v-layout>
                  <v-flex xs3 md3 wrap>
                    <v-select
                      v-model="countryCode"
                      :items="countryCodes"
                      :rules="[rules.required]"
                      color="#26af82"
                      label="Code"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs19 md9 pl-5>
                    <v-text-field
                      ref="phoneNo"
                      v-model="phoneNo"
                      :rules="[rules.required,rules.phone]"
                      label="Phone Number"
                      color="#26af82"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- <v-select
                  v-model="queryType"
                  :items="queryTypes"
                  :rules="[rules.required]"
                  color="#26af82"
                  item-color="#26af82"
                  label="Query Type"
                  required
                ></v-select>-->
                <v-layout wrap justify-center>
                  <v-flex xs12 sm12 md12>
                    <span style="font-size:14px;font-weight:300">Query Type</span>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-radio-group v-model="queryType" row>
                      <v-radio
                        v-for="(item,i) in queryTypes"
                        :key="i"
                        color="#26af82"
                        :label="item"
                        :value="item"
                        :ripple="false"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout wrap justify-center>
              <v-flex xs12 md6 px-5 text-center>
                <v-card outlined>
                  <v-layout pa-2 wrap justify-center>
                    <v-flex xs12 sm12 md12>
                      <v-textarea
                        rows="1"
                        ref="msgsubject"
                        v-model="msgsubject"
                        :rules="[rules.required]"
                        color="#26af82"
                        auto-grow
                        label="Subject"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-textarea
                        rows="5"
                        ref="msgbody"
                        v-model="msgbody"
                        :rules="[rules.required,rules.max]"
                        hint="max 1000 characters"
                        persistent-hint
                        color="#26af82"
                        auto-grow
                        label="Message"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center>
              <v-flex xs12 md12 pb-10 text-center>
                <span style="font-size:10px;color:red;">{{msg}}</span>
                <br />
                <v-btn
                  width="220"
                  class="text-capitalize"
                  dark
                  small
                  :ripple="false"
                  color="#26af82"
                  @click="submit"
                >Submit</v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["signupData"],
  data() {
    return {
      firstName: null,
      lastName: null,
      countryCode: "+91",
      phoneNo: null,
      mailId: null,
      userType: null,
      userTypes: ["Individual", "Company"],
      countryCodes: ["+61", "+65", "+91"],
      queryType: "Query",
      queryTypes: ["Query", "Feedback", "Complaint"],
      msgsubject: null,
      msgbody: null,
      investor: true,
      company: false,
      investorBar: 100,
      companyBar: 0,
      rules: {
        required: value => !!value || "Required",
        min: value => (!!value && value.length >= 8) || "Min 8 characters",
        max: value => (!!value && value.length < 1000) || "Max 1000 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid Mail ID";
        },
        phone: value => {
          const pattern = /^[0-9+]*$/;
          return pattern.test(value) || "Invalid Phone Number";
        }
      },
      msg: null,
      formHasErrors: false,
      appLoading: false,
      inptDisable: false,
      userId: null,
      authcode: null,
      ServerError: false
    };
  },
  computed: {
    form() {
      return {
        firstName: this.firstName,
        lastName: this.lastName,
        mailId: this.mailId,
        phoneNo: this.phoneNo,
        msgsubject: this.msgsubject,
        msgbody: this.msgbody
        // userType:this.userType
      };
    }
  },
  beforeMount() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.userType = localStorage.getItem("userType");
      if (this.userType) {
        this.appLoading = true;
        axios({
          method: "GET",
          url: "/user/profile",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          }
        })
          .then(response => {
            this.appLoading = false;
            this.firstName = response.data.data.individual.firstName;
            this.lastName = response.data.data.individual.lastName;
            this.mailId = response.data.data.email;
            this.countryCode = response.data.data.phonePrefix;
            this.phoneNo = response.data.data.phone;
            this.userId = response.data.data._id;
            this.userType = response.data.data.type;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      }
    },
    investoracc() {
      this.investor = true;
      this.userType = "Individual";
      this.company = false;
      this.investorBar = 100;
      this.companyBar = 0;
    },
    companyacc() {
      this.company = true;
      this.userType = "Company";
      this.investor = false;
      this.companyBar = 100;
      this.investorBar = 0;
    },
    submit() {
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;

        this.$refs[f].validate(true);
      });
      if (!this.formHasErrors) {
        this.appQuery();
      } else {
        // this.msg = "Please Validate INput";
      }
    },
    appQuery() {
      var querydata = {};
      querydata["firstname"] = this.firstName;
      querydata["lastname"] = this.lastName;
      if (this.userId != null) querydata["userid"] = this.userId;
      if (this.userId == null) querydata["usertype"] = "guest";
      else querydata["usertype"] = this.userType;
      querydata["email"] = this.mailId;
      querydata["prefix"] = this.countryCode;
      querydata["phone"] = this.phoneNo;
      querydata["queryType"] = this.queryType;
      querydata["subject"] = this.msgsubject;
      querydata["content"] = this.msgbody;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/query/add",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: querydata
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
            // this.msg = "Successfully Registered";
            this.$router.push("/QuerySuccess");
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
  }
}
</style>